export default __webpack_public_path__ + "static/Innovation-b893a026b3185139c5b1f9ceeb9222c8.jpg";